var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "business-information" },
    [
      _c("fieldset", { staticClass: "info-group" }, [
        _c("legend", [
          _vm._v(_vm._s(_vm.$t("kyc.section.businessInformation"))),
        ]),
      ]),
      _c("vuestic-widget", { attrs: { id: "dategridPayOrder" } }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table table-striped first-td-padding" }, [
            _c("thead", [
              _c(
                "tr",
                _vm._l(_vm.tableHeaderList, function (item, index) {
                  return _c("th", { key: index }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm._f("translate")(item.label)) +
                        "\n            "
                    ),
                  ])
                }),
                0
              ),
            ]),
            _vm.currentList
              ? _c(
                  "tbody",
                  _vm._l(_vm.currentList, function (item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(item.app_name))]),
                      _c("td", [_vm._v(_vm._s(item.website))]),
                      _c("td", [_vm._v(_vm._s(item.industry))]),
                      _c("td", [_vm._v(_vm._s(item.complaint_email))]),
                    ])
                  }),
                  0
                )
              : _c("tbody", [
                  _c("tr", [
                    _c("td", {
                      attrs: { colspan: "11" },
                      domProps: {
                        textContent: _vm._s(_vm.$t("t.noDataNoOrder")),
                      },
                    }),
                  ]),
                ]),
          ]),
        ]),
        _vm.isMobile === "pc"
          ? _c(
              "div",
              { staticClass: "block" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total>0",
                    },
                  ],
                  attrs: {
                    total: _vm.total,
                    "page-size": _vm.limit,
                    layout: "total, sizes, prev, pager, next, jumper",
                    background: "",
                    page: _vm.page,
                    limit: _vm.limit,
                    pageSizes: _vm.pageSizes,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "update:limit": function ($event) {
                      _vm.limit = $event
                    },
                    pagination: _vm.orderData,
                  },
                }),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "block" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.total > 0,
                      expression: "total>0",
                    },
                  ],
                  attrs: {
                    total: _vm.total,
                    layout: "total, prev, pager, next",
                    background: "",
                    page: _vm.page,
                    limit: _vm.limit,
                    pageSizes: _vm.pageSizes,
                  },
                  on: {
                    "update:page": function ($event) {
                      _vm.page = $event
                    },
                    "update:limit": function ($event) {
                      _vm.limit = $event
                    },
                    pagination: _vm.orderData,
                  },
                }),
              ],
              1
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }